import React, { useState } from "react";
import { Input } from "../../ui/input";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import { Button } from "../../ui/button";
import { FaSearch } from "react-icons/fa";
import { cn } from "../../../lib/utils";

// search option: {key: goes to mongodb, label: what user sees, value: is the value of the search, regex: true or false, ids NO.}
const TableSearch = ({ searchByOptions, onSearchChange }: any) => {
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState(searchByOptions[0]);
  const [searchByMenuOpen, setSearchByMenuOpen] = useState(false);

  const handleActiveElement = (elem: any) => {
    setSearchBy(elem);
    setSearchByMenuOpen(false);
  };

  const handleSearchClick = () => {
    onSearchChange({
      ...searchBy,
      value: search,
    });
  };

  const handleResetSearch = () => {
    setSearch("");

    onSearchChange({
      ...searchBy,
      value: "",
    });
  };

  return (
    <div className="flex w-full">
      <Input
        type="text"
        placeholder="Search"
        className="bg-transparent text-white border-primary placeholder border-r-0 border-t-1 rounded-r-none"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearchClick();
          }

          if (e.key === "Escape") {
            handleResetSearch();
          }
        }}
      />

      <DropdownMenu modal={false} open={searchByMenuOpen}>
        <DropdownMenuTrigger
          onClick={() => setSearchByMenuOpen(!searchByMenuOpen)}
          asChild
        >
          <div
            style={{
              border: "1px solid transparent",
              borderRight: "0",
              borderTopLeftRadius: 0,
              borderBottomLeftRadius: 0,
              borderRadius: 0,
            }}
            className={cn(
              "relative hover:bg-primary/90 bg-primary cursor-pointer object-contain rounded flex items-center justify-between px-2",
              "h-10 w-1/2"
            )}
          >
            <span className="text-sm font-semibold text-white">
              {searchBy.label}
            </span>

            <ChevronDown className="h-4 w-4 ms-2 mt-1" />
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="mt-1 flex flex-col gap-y-1 border-none bg-black drop-shadow-2xl py-2 text-white">
          {searchByOptions.map((elem: any) => {
            return (
              <div
                key={elem?.label}
                onClick={() => {
                  handleActiveElement(elem);
                }}
                className={`flex h-fit justify-between gap-10 rounded-none px-5 py-2 focus:border-none hover:cursor-pointer hover:bg-primary ${
                  searchBy.key === elem?.key ? "bg-primary" : ""
                }`}
              >
                <div className="group flex items-center gap-2">
                  <p
                    className={`text-sm 
                   ${searchBy.key === elem?.key ? "text-white" : "text-white"}`}
                  >
                    {elem?.label}
                  </p>
                </div>
              </div>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>

      <Button
        style={{
          borderLeft: "0",
        }}
        className="rounded-l-none"
        onClick={handleSearchClick}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearchClick();
          }

          if (e.key === "Escape") {
            handleResetSearch();
          }
        }}
      >
        <FaSearch />
      </Button>
    </div>
  );
};

export default TableSearch;
